import React from 'react';
import {
  TableData,
  TableRow,
  formatHash,
  HashLength,
  formatTimestamp,
  Tooltip,
  formatTimestampAge,
  Link
} from '@make-software/cspr-design';

import { Message } from '@/entities';
import { AccountInfoCell } from './account-info-cell';
import { HistoryLink } from './history-link';

import { StyledMessageText, StyledTimeText } from './styled';

interface MessageTableRowProps {
  message: Message;
  onRead: (message: Message) => void;
}

export const MessageTableRow: React.FC<MessageTableRowProps> = ({ message, onRead }) => {
  const transactionLink = `${config.cspr_live_url}/transaction/${message.transactionHash}`;

  return (
    <TableRow>
      <TableData>
        <AccountInfoCell
          accountHash={message.senderPublicKey}
          publicKey={message.senderPublicKey}
        />
      </TableData>

      <TableData>
        <AccountInfoCell
          accountHash={message.recipientPublicKey}
          publicKey={message.recipientPublicKey}
        />
      </TableData>

      <TableData>
        <StyledMessageText size={3} scale="sm" monotype>
          <Link color="hash" onClick={() => onRead(message)}>
            {formatHash(message.body, HashLength.MEDIUM)}
          </Link>
        </StyledMessageText>
      </TableData>

      <TableData>
        <Tooltip
          scale={'xs'}
          lineHeight={'xs'}
          paddingScale={1}
          tooltipContent={formatTimestamp(message.timestamp)}
          monotype>
          <StyledTimeText size={3} noWrap>
            <HistoryLink href={transactionLink} target={'_blank'} monotype>
              {formatTimestampAge(message.timestamp)}
            </HistoryLink>
          </StyledTimeText>
        </Tooltip>
      </TableData>
    </TableRow>
  );
};
